import { Dialog, DialogTitle, Fab, Grid, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { allRoles } from 'config';
import CheckIcon from '@mui/icons-material/Check';
import config, { prodProjeEskgId, projeEskgId, testProjeEskgId } from '../../../config';
import RoleUnitDataTable from '../DataTable/RoleUnitDataTable';
import { useSelector } from 'react-redux';
import { isRoleCheckList } from 'app/utils/appHelpers';
import { useTemplateFontSettings } from 'styles/templateFontSettings';

function RoleDStatusListDialog({ handleCloseRole, onClose, open, pageTitle }) {



  const [loading, setLoading] = useState(true);
  let [allRolesData, setAllRolesData] = useState([]);
  const [allInstData, setAllInstData] = useState([]);

  const [openInstDialog, setOpenInstDialog] = useState(false);
  const [openRoleDialog, setOpenRoleDialog] = useState();
  const [selectedRole, setSelectedRole] = useState(false);

  const authUser = useSelector(state => state.auth.authUser);
  const allAuthorizedInsts = useSelector(state => state.auth.allAuthorizedInsts);


  const handleListItemClick = async (item, selectedDialogType) => {
    if (selectedDialogType === 1) { // rol dialogu

      setSelectedRole(item.roleId);
      setOpenInstDialog(true);

      if (item.roleId === 417) {
        const instList = config.institutions.filter(x => allAuthorizedInsts.includes(x.inst) && x.inst !== 'YK');
        setAllInstData(instList);
      }

    } else if (selectedDialogType === 2) { // inst dialogu

      setOpenInstDialog(false);
      setOpenRoleDialog(false);

      await handleCloseRole(selectedRole, item.inst);

    }
  };


  const handleClose = async () => {
    setOpenInstDialog(false);
    setOpenRoleDialog(false);


    setSelectedRole(null)
    onClose();
  };




  useEffect(() => {
    let rolesData = [];

    if (open === true) {
      rolesData = allRoles.filter(x => x.roleId === 416 || x.roleId === 417);
      setOpenRoleDialog(true);
      let instList = [];
      if (isRoleCheckList(authUser.userRoles, [370])) {
        instList = config.institutions;
      } else {
        instList = config.institutions.filter(x => allAuthorizedInsts.includes(x.inst));
      }
      setAllInstData(instList);
      if (isRoleCheckList(authUser.userRoles, [370])) {
        rolesData = allRoles.filter(x => x.roleId === 416);
      }

      setAllRolesData(rolesData); // Set the roles data
    }

  }, [open])


  
  return (

    <React.Fragment>

      <Dialog onClose={handleClose} open={openRoleDialog} maxWidth="xs" fullWidth scroll="paper">
        <DialogTitle sx={{  }}>{pageTitle} / Rol Seçiniz</DialogTitle>
        <Grid container spacing={2}>

          <Grid item xs={12} sm={12} lg={12} >

            <List disablePadding>
              {allRolesData.map((item) => (

                <ListItemButton
                  component={"li"}
                  alignItems={"flex-start"}
                  sx={{
                    borderBottom: 1,
                    borderBottomColor: 'divider',
                    px: 3,

                    // '&:hover .ListItemIcons': {
                    //   opacity: 1
                    // }
                  }}
                >

                  <ListItemText
                    primary={<Typography component={"div"}>
                      <Typography variant={"body1"} mb={1} sx={{  }}>

                        {item.name}
                      </Typography>
                    </Typography>} />

                  <ListItemIcon
                    className={"ListItemIcons"}
                    sx={{
                      position: 'absolute',
                      right: 10,
                      bottom: 6,
                      transition: 'all 0.2s',
                      // opacity: 0,
                    }}
                  >
                    <Fab size="small" color={"primary"} onClick={() => handleListItemClick(item, 1)} key={item.roleId}
                      sx={{
                        bgcolor: 'grey.300',
                        '&:hover': {
                          bgcolor: (theme) => theme.palette.primary.main
                        },
                        width: 35,  // özel genişlik
                        height: 35, // özel yükseklik
                        minHeight: 35, // minimum yükseklik
                        '& .MuiSvgIcon-root': { // icon boyutu
                          fontSize: '1rem'
                        }
                      }}
                    ><CheckIcon /></Fab>

                  </ListItemIcon>
                </ListItemButton>

              ))}

            </List>
          </Grid>

        </Grid>
      </Dialog>


      <Dialog onClose={handleClose} open={openInstDialog} maxWidth="xs" fullWidth scroll="paper">
        <DialogTitle sx={{  }}>{pageTitle} / Kurum Seçiniz</DialogTitle>
        <Grid container spacing={2}>

          <Grid item xs={12} sm={12} lg={12}>

            <List disablePadding>

              {allInstData.map((item) => (


                <>

                  <ListItemButton
                    component={"li"}
                    alignItems={"flex-start"}
                    sx={{
                      borderBottom: 1,
                      borderBottomColor: 'divider',
                      px: 3,

                      // '&:hover .ListItemIcons': {
                      //   opacity: 1
                      // }
                    }}
                  >


                    <ListItemText
                      primary={<Typography component={"div"}>
                        <Typography variant={"body1"} mb={1} sx={{  }}>

                          {item.inst}
                        </Typography>
                      </Typography>} />

                    <ListItemIcon
                      className={"ListItemIcons"}
                      sx={{
                        position: 'absolute',
                        right: 10,
                        bottom: 6,
                        transition: 'all 0.2s',
                        // opacity: 0,
                      }}
                    >
                      <Fab size="small" color={"primary"} onClick={() => handleListItemClick(item, 2)} key={item.inst}

                        sx={{
                          bgcolor: 'grey.300',
                          '&:hover': {
                            bgcolor: (theme) => theme.palette.primary.main
                          },
                          width: 35,
                          height: 35,
                          minHeight: 35,
                          '& .MuiSvgIcon-root': {
                            fontSize: '1rem'
                          }
                        }}
                      ><CheckIcon /></Fab>

                    </ListItemIcon>


                  </ListItemButton>


                </>



              ))}


            </List>

          </Grid>
        </Grid>
      </Dialog>



    </React.Fragment >
  );
}


export default RoleDStatusListDialog